import * as React from 'react';
import '../playerstatselection.css'
import Player from "../../fbobjects/Player";
import {ChampionRunes, SimRunes} from "../../fbobjects/calculation/CalculationObjects";
import {number} from "@kadira/storybook-addon-knobs";
import _ = require("lodash");
import {SimStats} from "../../fbobjects/calculation/SimStats";
import {StatBlock, StatBlockProps} from "../StatModalComponent/index";

interface RunePageProps {
    runePage: ChampionRunes

}

export default class RunePage extends React.Component<RunePageProps,any> {

    getRuneStats(runeStats: SimRunes) {
        let divsToReturn = [];
        _.forOwn(runeStats, (value, key) => {
            if (SimStats.getNameForStat(key) != undefined && value != 0) {
                divsToReturn.push(<div className="stat" key={key}>
                    <div className="number">
                        {value.toFixed(2)}
                    </div>
                    <div>
                        {SimStats.getNameForStat(key)}
                    </div>
                </div>)
            }
        });
        return divsToReturn;
    }

    render() {
        return (
            <div className="rune-page">
                {/*<div className="name">*/}
                    {/*{this.props.runePage.runes.name.toUpperCase()}*/}
                {/*</div>*/}

                {/*<div className="divider"/>*/}
                <div className="stats">
                    {this.getRuneStats(this.props.runePage.runes)}
                </div>
                {/*<div className="divider"/>*/}
                {/*<div className="when">*/}
                    {/*{this.props.runePage.when}*/}
                {/*</div>*/}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/RunePage/index.tsx